import { BaseComponent2 } from '../../_common/client/base-component2';
import { registerViewTracking } from './helpers/register-view-tracking';
import { registerEventTracking } from './helpers/register-event-tracking';
import { addNonPdpFeaturesToPageImpression } from '../../_common/client/tracking/add-non-pdp-features-to-page-impression';
import { registerMoveTracking } from './helpers/register-move-tracking';

export class CustomerReviewLandingPageTrackingComponent extends BaseComponent2 {
    public rootSelector = '.js_cr_landing-page-tracking';

    public async onFirstPageLoadOncePerComponentType(): Promise<void> {
        registerViewTracking();
    }

    public async init(): Promise<void> {
        if (!this.isPresent()) return;

        const variationId = this.readVariationIdFromHtml();
        addNonPdpFeaturesToPageImpression(variationId);
        registerEventTracking(variationId);
        registerMoveTracking(variationId);
    }

    private readVariationIdFromHtml() {
        return this.getRootElement().dataset.variationId ?? '';
    }
}
